"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BodyStatus;
(function (BodyStatus) {
    BodyStatus["CLOSED"] = "CLOSED";
    BodyStatus["OPEN_ABOVE"] = "OPEN_ABOVE";
    BodyStatus["OPEN_BELOW"] = "OPEN_BELOW";
})(BodyStatus || (BodyStatus = {}));
exports.default = BodyStatus;
//# sourceMappingURL=BodyStatus.js.map